import { getAssetImage } from "@/service/image/asset";
import { createAbsoluteUrl } from "@/service/url";
import { JsonLd } from "@/components/common/structured-data/json-ld";

// Ten sam `@id` w `publisher`/`author` na każdej stronie wiąże je z pełnym opisem ze strony głównej.
export const remediumOrganization = {
  "@type": "Organization",
  "@id": createAbsoluteUrl("/#organization"),
  name: "Remedium",
  url: createAbsoluteUrl("/"),
  logo: {
    "@type": "ImageObject",
    url: getAssetImage("/favicon.png"),
  },
};

export const OrganizationStructuredData = () => {
  return (
    <>
      <JsonLd
        data={{
          ...remediumOrganization,
          sameAs: [
            "https://www.facebook.com/remedium.md",
            "https://www.instagram.com/remedium.md/",
            "https://x.com/remedium_md",
            "https://apps.apple.com/pl/app/remedium/id1666340112",
            "https://play.google.com/store/apps/details?id=md.remedium.app",
          ],
        }}
      />
      <JsonLd
        data={{
          "@type": "WebSite",
          "@id": createAbsoluteUrl("/#website"),
          name: "Remedium",
          alternateName: "remedium.md",
          url: createAbsoluteUrl("/"),
          inLanguage: "pl-PL",
          publisher: { "@id": remediumOrganization["@id"] },
        }}
      />
    </>
  );
};
